// src/Pages/Dashboard/Sales/Delivery_Challans.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Delivery_Challans.css";

const Delivery_Challans = () => {
  const [challans, setChallans] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const backendUrl =
    process.env.REACT_APP_BACKEND_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://finance.dev.marsforce.in"
      : "http://localhost:8030");

  useEffect(() => {
    if (location.state?.refresh) {
      fetchChallans();
      window.history.replaceState({}, "");
    } else {
      fetchChallans();
    }
  }, [location]);

  const fetchChallans = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await fetch(`${backendUrl}/api/delivery-challans/get`, {
        method: "GET",
        credentials: "include",
      });

      const data = await res.json();

      if (data.success) {
        setChallans(data.data || []);
      } else {
        setError(data.error || "Failed to load delivery challans");
      }
    } catch (err) {
      setError("Network error. Please check your connection.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filteredChallans = challans.filter(
    (ch) =>
      (ch.challanNo || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (ch.customerName || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleRowClick = (challan) => {
    navigate(`/sales/delivery-challans/${challan._id}`);
  };

  const formatCurrency = (amount) => {
    return (
      "₹" +
      Number(amount || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  };

  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString("en-IN");
    } catch {
      return "-";
    }
  };

  return (
    <div className="delivery-wrapper">
      <div className="delivery-challans-container">
        {/* Header */}
        <div className="delivery-challans-header">
          <h1>All Delivery Challans</h1>
          <div className="header-actions">
            <input
              type="text"
              placeholder="Search by Challan# or Customer..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Link to="/sales/delivery-challans/new">
              <button className="new-challan-btn">
                <span>+</span> New Challan
              </button>
            </Link>
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="state-card">
            <p>Loading delivery challans...</p>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="state-card error">
            <p>Warning: {error}</p>
            <button onClick={fetchChallans} className="retry-btn">
              Try Again
            </button>
          </div>
        )}

        {/* Empty State */}
        {!loading && !error && challans.length === 0 && (
          <div className="state-card empty">
            <h3>No Delivery Challans Yet</h3>
            <p>Create your first delivery challan to get started!</p>
            <Link to="/sales/delivery-challans/new">
              <button className="new-challan-btn">
                + Create First Challan
              </button>
            </Link>
          </div>
        )}

        {/* Challans List */}
        {!loading && !error && challans.length > 0 && (
          <div className="challans-list-full">
            {/* Desktop Table Header */}
            <div className="table-header-row">
              <span></span>
              <span>DATE</span>
              <span>CHALLAN#</span>
              <span>REFERENCE#</span>
              <span>CUSTOMER NAME</span>
              <span>TYPE</span>
              <span>AMOUNT</span>
            </div>

            {/* Rows or No Results */}
            {filteredChallans.length === 0 ? (
              <div className="state-card no-results">
                <p>No challans found for "{searchTerm}"</p>
              </div>
            ) : (
              filteredChallans.map((ch) => (
                <div
                  key={ch._id}
                  className="challan-row"
                  onClick={() => handleRowClick(ch)}
                >
                  <input type="checkbox" onClick={(e) => e.stopPropagation()} />
                  <span data-label="Date">{formatDate(ch.challanDate)}</span>
                  <span data-label="Challan#" className="challan-no">
                    {ch.challanNo}
                  </span>
                  <span data-label="Reference#">{ch.referenceNo || "-"}</span>
                  <span data-label="Customer" className="customer-name">
                    {ch.customerName}
                  </span>
                  <span data-label="Type" className="type-badge">
                    {ch.challanType || "Others"}
                  </span>
                  <span data-label="Amount" className="amount">
                    {formatCurrency(ch.total)}
                  </span>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Delivery_Challans;
